import { render } from "./contact.vue?vue&type=template&id=ed4f5938&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=ed4f5938&lang=less&scoped=true"

import exportComponent from "/Users/ym/Desktop/tianmuli/tml-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed4f5938"]])

export default __exports__